import SankeyVisualization from "views/components/visualizations/sankey/SankeyVisualization";
const countGroupingFields = (formValues) => {
  var _a, _b;
  return ((_b = (_a = formValues.groupBy) == null ? void 0 : _a.groupings) != null ? _b : []).reduce((total, grouping) => {
    var _a2, _b2;
    return total + ((_b2 = (_a2 = grouping.fields) == null ? void 0 : _a2.length) != null ? _b2 : 0);
  }, 0);
};
const validate = (formValues) => {
  var _a, _b;
  if (countGroupingFields(formValues) < 2) {
    return { type: "Sankey requires at least two grouping fields." };
  }
  if (((_b = (_a = formValues.metrics) == null ? void 0 : _a.length) != null ? _b : 0) > 1) {
    return { type: "Sankey supports only a single metric." };
  }
  return {};
};
const sankey = {
  type: SankeyVisualization.type,
  displayName: "Sankey",
  component: SankeyVisualization,
  validate
};
export default sankey;
